import _asyncToGenerator from "/home/circleci/project/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/circleci/project/node_modules/@babel/runtime/regenerator/index.js";
/**
 *
 * @param condition - predicate function that, if true, will cause the promise to resolve.
 * @param delayMs - The frequency, in milliseconds (thousandths of a second), to check the condition.
 * @example
 * ```ts
 * // check 'readyState' every 500ms
 * await resolveWhen(() => document.readyState === 'complete', 500)
 * ```
 */
export function resolveWhen(_x, _x2) {
  return _resolveWhen.apply(this, arguments);
}
function _resolveWhen() {
  _resolveWhen = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(condition, delayMs) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", new Promise(function (resolve, _reject) {
            if (condition()) {
              resolve();
              return;
            }
            var check = function check() {
              return setTimeout(function () {
                if (condition()) {
                  resolve();
                } else {
                  check();
                }
              }, delayMs);
            };
            check();
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _resolveWhen.apply(this, arguments);
}